"use client";

import { c as _c } from "react/compiler-runtime";
import { enUS, zhCN } from "date-fns/locale";
import Link from "next/link";
import { useCallback } from "react";
import { getLogCardCopy } from "@/components/dashboard/log-card-copy";
import { useFetchClient } from "@/lib/fetch-client";
import { useI18n } from "@llmgateway/i18n/react";
import { LogCard as SharedLogCard, type LogCardData } from "@llmgateway/shared/components";
import type { Log } from "@llmgateway/db";
type DashboardLog = Partial<Log> & {
  organizationName?: string | null;
  projectName?: string | null;
  apiKeyName?: string | null;
};
function NextLink(t0) {
  const $ = _c(4);
  const {
    href,
    className,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== className || $[2] !== href) {
    t1 = <Link href={href} className={className} prefetch={false}>{children}</Link>;
    $[0] = children;
    $[1] = className;
    $[2] = href;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
export function LogCard(t0) {
  const $ = _c(21);
  const {
    log,
    orgId,
    projectId
  } = t0;
  const fetchClient = useFetchClient();
  const {
    locale
  } = useI18n();
  let t1;
  if ($[0] !== locale) {
    t1 = getLogCardCopy(locale);
    $[0] = locale;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const copy = t1;
  const dateFnsLocale = locale === "zh-CN" ? zhCN : enUS;
  let t2;
  if ($[2] !== log || $[3] !== orgId || $[4] !== projectId) {
    t2 = orgId && projectId && log.id ? logId => `/dashboard/${orgId}/${projectId}/activity/${logId}` : undefined;
    $[2] = log;
    $[3] = orgId;
    $[4] = projectId;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const getDetailUrl = t2;
  let t3;
  if ($[6] !== orgId || $[7] !== projectId) {
    t3 = orgId && projectId ? logId_0 => `/dashboard/${orgId}/${projectId}/activity/${logId_0}` : undefined;
    $[6] = orgId;
    $[7] = projectId;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const getRetriedUrl = t3;
  let t4;
  if ($[9] !== fetchClient) {
    t4 = async logId_1 => {
      const {
        data
      } = await fetchClient.GET("/logs/{id}", {
        params: {
          path: {
            id: logId_1
          }
        }
      });
      return data?.log?.content ?? null;
    };
    $[9] = fetchClient;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const fetchImageContent = t4;
  let t5;
  if ($[11] !== fetchClient) {
    t5 = async logId_2 => {
      const {
        data: data_0
      } = await fetchClient.GET("/logs/{id}", {
        params: {
          path: {
            id: logId_2
          }
        }
      });
      const messages = data_0?.log?.messages;
      if (!messages) {
        return null;
      }
      const haystack = JSON.stringify(messages);
      const dataUrlRegex = /data:image\/[a-zA-Z0-9.+-]+;base64,[A-Za-z0-9+/=]+/g;
      const matches = haystack.match(dataUrlRegex);
      return matches && matches.length > 0 ? matches : null;
    };
    $[11] = fetchClient;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const fetchInputImages = t5;
  const t6 = log as LogCardData;
  let t7;
  if ($[13] !== copy || $[14] !== dateFnsLocale || $[15] !== fetchImageContent || $[16] !== fetchInputImages || $[17] !== getDetailUrl || $[18] !== getRetriedUrl || $[19] !== t6) {
    t7 = <SharedLogCard log={t6} getDetailUrl={getDetailUrl} getRetriedUrl={getRetriedUrl} renderLink={NextLink} showCopyButtons={true} isUserFacing={true} fetchImageContent={fetchImageContent} fetchInputImages={fetchInputImages} copy={copy} dateFnsLocale={dateFnsLocale} />;
    $[13] = copy;
    $[14] = dateFnsLocale;
    $[15] = fetchImageContent;
    $[16] = fetchInputImages;
    $[17] = getDetailUrl;
    $[18] = getRetriedUrl;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
}